import React, { useState, useMemo } from "react";
import { useGetVisitStatsQuery } from "store";
import { Bar } from "react-chartjs-2";
import {
    Box,
    Select,
    Text,
    useColorModeValue,
    Spinner,
    Flex,
    Button
} from "@chakra-ui/react";
import { useNavigate } from 'react-router-dom';

const VisitsChart = () => {
    const [timeframe, setTimeframe] = useState("day");
    const { data: chartData, isFetching, error } = useGetVisitStatsQuery({
        timeframe,
    });
    const navigate = useNavigate();

    const backgroundColor = useColorModeValue(
        "rgba(66, 153, 225, 0.5)",
        "rgba(66, 153, 225, 0.8)"
    );
    const borderColor = useColorModeValue(
        "rgba(66, 153, 225, 1)",
        "rgba(66, 153, 225, 0.9)"
    );

    const data = useMemo(
        () => ({
            labels: chartData?.map((item) => item.v_date),
            datasets: [
                {
                    label: "Number of Visits",
                    data: chartData?.map((item) => item.count),
                    backgroundColor,
                    borderColor,
                    borderWidth: 1,
                },
            ],
        }),
        [chartData, backgroundColor, borderColor]
    );

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: "top",
            },
        },
        scales: {
            y: {
                beginAtZero: true,
            },
        },
    };

    return (
        <Box
            p="4"
            bg={useColorModeValue("white", "gray.700")}
            borderRadius="lg"
            boxShadow="md"
        >
            <Flex justifyContent="space-between" mb="4">
                <Text fontSize="xl" fontWeight="bold">
                    Visit Statistics
                </Text>
                <Select
                    onChange={(e) => setTimeframe(e.target.value)}
                    value={timeframe}
                    w="auto"
                >
                    <option value="day">Daily</option>
                    <option value="week">Weekly</option>
                    <option value="month">Monthly</option>
                    <option value="year">Yearly</option>
                </Select>
                <Button
                    ml="4"
                    size="sm"
                    colorScheme="teal"
                    onClick={() => navigate("/visits")}
                >
                    See All
                </Button>
            </Flex>
            {isFetching ? (
                <Flex justify="center" align="center" h="200px">
                    <Spinner
                        thickness="4px"
                        speed="0.65s"
                        emptyColor="gray.200"
                        color="blue.500"
                        size="xl"
                    />
                </Flex>
            ) : error ? (
                <Text color="red.500">Error: {error.message}</Text>
            ) : (
                <Bar data={data} options={options} />
            )}
        </Box>
    );
};

export default VisitsChart;
